const $j = (typeof window !== 'undefined' && (window as Window & { $j: unknown }).$j) || (() => {}) as (s: string) => unknown;

export function mobile(): void {
    if (!($j('#site-overlay') as { length: number }).length) {
        ($j('body') as { append: (html: string) => void }).append('<div id="site-overlay"></div>');
        ($j('.hamburger') as { click: (fn: () => void) => void }).click(function () {
            (($j as (el: unknown) => unknown)(this) as { toggleClass: (c: string) => void }).toggleClass('is-active');
            if (!($j('body.oc-open') as { length: number }).length) {
                ($j('#nav, #site-overlay') as { fadeIn: (n: number) => void }).fadeIn(200);
                ($j('body') as { addClass: (c: string) => void }).addClass('oc-open');
            } else {
                ($j('#nav, #site-overlay') as { fadeOut: (n: number) => void }).fadeOut(200);
                ($j('body') as { removeClass: (c: string) => void }).removeClass('oc-open');
            }
        });
        ($j('#site-overlay') as { click: (fn: () => void) => void }).click(function () {
            ($j('#oc-btn') as { click: () => void }).click();
        });
    }
}
